'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactAddonsCreateFragment = require('react-addons-create-fragment');

var _reactAddonsCreateFragment2 = _interopRequireDefault(_reactAddonsCreateFragment);

var _recompose = require('recompose');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _sortObject = require('./utils/sortObject');

var _sortObject2 = _interopRequireDefault(_sortObject);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

/**
 *
 */
var Field = function Field(_ref) {
	var children = _ref.children;
	var name = _ref.name;
	var label = _ref.label;
	var _ref$hint = _ref.hint;
	var hint = _ref$hint === undefined ? '' : _ref$hint;
	var _ref$error = _ref.error;
	var error = _ref$error === undefined ? '' : _ref$error;
	var _ref$required = _ref.required;
	var required = _ref$required === undefined ? false : _ref$required;
	var _ref$order = _ref.order;
	var order = _ref$order === undefined ? [Field.LABEL, Field.HINT, Field.ERROR, Field.INPUT] : _ref$order;

	var input = _react.Children.only(children);
	var id = 'rea11y-Field-' + name;
	var inputId = id + '-input';
	var labelId = id + '-label';
	var labels = [labelId];

	var components = _defineProperty({}, Field.LABEL, _react2.default.createElement(
		'label',
		{
			id: labelId,
			className: 'rea11y-Field-label',
			htmlFor: inputId
		},
		label
	));

	if (hint) {
		var hintId = id + '-hint';

		labels.push(hintId);
		components[Field.HINT] = _react2.default.createElement(
			'p',
			{ id: hintId, className: 'rea11y-Field-hint' },
			hint
		);
	}

	if (error) {
		var errorId = id + '-error';

		labels.push(errorId);
		components[Field.ERROR] = _react2.default.createElement(
			'p',
			{ id: errorId, className: 'rea11y-Field-error' },
			error
		);
	}

	var inputProps = {
		id: inputId,
		name: inputId,
		className: 'rea11y-Field-input',
		'aria-labelledby': labels.join(' ')
	};

	if (required) {
		inputProps.required = true;
		inputProps['aria-required'] = true;
	}

	if (error) {
		inputProps['aria-invalid'] = true;
	}

	components[Field.INPUT] = (0, _react.cloneElement)(input, inputProps);

	var fragment = (0, _reactAddonsCreateFragment2.default)((0, _sortObject2.default)(components, order));

	var className = (0, _classnames2.default)('rea11y-Field', 'rea11y-Field-' + name);

	return _react2.default.createElement(
		'div',
		{ className: className },
		fragment
	);
};

Field.LABEL = 'label';
Field.HINT = 'hint';
Field.ERROR = 'error';
Field.INPUT = 'input';

Field.propTypes = {
	name: _react.PropTypes.string,
	label: _react.PropTypes.string,
	hint: _react.PropTypes.string,
	error: _react.PropTypes.string,
	required: _react.PropTypes.bool,
	order: _react.PropTypes.arrayOf(_react.PropTypes.oneOf([Field.LABEL, Field.HINT, Field.ERROR, Field.INPUT])),
	children: _react.PropTypes.element.isRequired
};

exports.default = (0, _recompose.pure)(Field);